import React from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import {X} from 'lucide-react';
import {useAuthForm} from '@/contexts/AuthFormProvider';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthTopBar: React.FC = () => {
    const {isOpen, formType, closeForm} = useAuthForm();

    console.log('📋 [AuthTopBar] Render', {
        isOpen,
        formType,
        timestamp: new Date().toISOString()
    });

    return (
        <>
            <AnimatePresence>
                {isOpen && (
                    <>
                        {console.log('📋 [AuthTopBar] Modal is VISIBLE')}
                        {/* Backdrop */}
                        <motion.div
                            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999]"
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.3}}
                            onClick={() => {
                                console.log('📋 [AuthTopBar] Backdrop clicked');
                                closeForm();
                            }}
                        />

                        {/* Expandable Top Bar */}
                        <motion.div
                            className="fixed top-0 left-0 right-0 z-[10000]"
                            initial={{height: 0, opacity: 0}}
                            animate={{
                                height: '100vh',
                                opacity: 1
                            }}
                            exit={{height: 0, opacity: 0}}
                            transition={{
                                duration: 0.5,
                                ease: [0.25, 0.46, 0.45, 0.94]
                            }}
                        >
                            {/* Glass Effect Background */}
                            <div
                                className="absolute inset-0 bg-gradient-to-br from-gray-900/95 via-slate-800/95 to-gray-900/95 backdrop-blur-xl border-b border-white/10">
                                {/* Subtle Pattern Overlay */}
                                <div
                                    className="absolute inset-0 opacity-5"
                                    style={{
                                        backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.3) 1px, transparent 0)`,
                                        backgroundSize: '24px 24px'
                                    }}
                                />

                                {/* Gradient Orbs */}
                                <div
                                    className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"/>
                                <div
                                    className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl"/>
                            </div>

                            {/* Content Container */}
                            <div className="relative z-20 flex flex-col h-full">


                                {/* Form Content */}
                                <div className="flex-1 flex flex-col px-4 sm:px-6 lg:px-8 pb-6 sm:pb-8 pt-24 sm:pt-32 overflow-y-auto">
                                    {/* Form Container with Close Button */}
                                    <div className="flex-1 flex items-start justify-center min-h-0">
                                        <motion.div
                                            initial={{opacity: 0, y: 20}}
                                            animate={{opacity: 1, y: 0}}
                                            exit={{opacity: 0, y: -20}}
                                            transition={{duration: 0.4, delay: 0.2}}
                                            className="w-full max-w-md relative"
                                        >
                                            {/* Close Button - Next to Form */}
                                            <motion.div
                                                className="absolute -top-2 -right-2 sm:-top-4 sm:-right-4 z-10"
                                                initial={{opacity: 0, scale: 0.8}}
                                                animate={{opacity: 1, scale: 1}}
                                                exit={{opacity: 0, scale: 0.8}}
                                                transition={{duration: 0.3, delay: 0.1}}
                                            >
                                                <motion.button
                                                    onClick={() => {
                                                        console.log('📋 [AuthTopBar] Close X button clicked');
                                                        closeForm();
                                                    }}
                                                    className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 shadow-xl"
                                                    whileHover={{scale: 1.1}}
                                                    whileTap={{scale: 0.9}}
                                                >
                                                    <X className="w-5 h-5 sm:w-6 sm:h-6"/>
                                                </motion.button>
                                            </motion.div>
                                            
                                            {/* Form Components */}
                                            {formType === 'login' && <LoginForm/>}
                                            {formType === 'register' && <RegisterForm/>}
                                            {formType === 'forgotPassword' && <LoginForm/>}
                                            {formType === 'confirmForgotPassword' && <LoginForm/>}
                                        </motion.div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>

        </>
    );
};

export default AuthTopBar;